/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * LearningModuleBase
 * auto generated base class for the model LearningModuleModel.
 */
export const LearningModuleModelBase = ModelBase.named('LearningModule')
  .props({
    __typename: types.optional(types.literal('LearningModule'), 'LearningModule'),
    _id: types.identifier,
    categoryId: types.union(types.undefined, types.number),
    categoryName: types.union(types.undefined, types.string),
    createdAt: types.union(types.undefined, types.frozen()),
    moduleId: types.union(types.undefined, types.number),
    moduleImageUrl: types.union(types.undefined, types.string),
    moduleTitle: types.union(types.undefined, types.string),
    topicId: types.union(types.undefined, types.number),
    topicName: types.union(types.undefined, types.string),
    updatedAt: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LearningModuleModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get categoryId() {
    return this.__attr('categoryId')
  }
  get categoryName() {
    return this.__attr('categoryName')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get moduleId() {
    return this.__attr('moduleId')
  }
  get moduleImageUrl() {
    return this.__attr('moduleImageUrl')
  }
  get moduleTitle() {
    return this.__attr('moduleTitle')
  }
  get topicId() {
    return this.__attr('topicId')
  }
  get topicName() {
    return this.__attr('topicName')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
}
export function selectFromLearningModule() {
  return new LearningModuleModelSelector()
}

export const learningModuleModelPrimitives =
  selectFromLearningModule()._id.categoryId.categoryName.createdAt.moduleId.moduleImageUrl.moduleTitle.topicId.topicName
    .updatedAt
